import { Buildings, Cash, CreditCard } from "@medusajs/icons";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.error("Missing VITE_STRIPE_PUBLISHABLE_KEY environment variable");
}

/**
 * Singleton Stripe.js promise.
 * loadStripe is idempotent — calling it multiple times returns the same instance.
 */
export const stripePromise = loadStripe(stripePublishableKey || "");

/* Map of payment provider_id to their title and icon. Add in any payment providers you want to use. */
export const paymentInfoMap: Record<
  string,
  { title: string; icon: React.JSX.Element }
> = {
  pp_system_default: {
    title: "Manual Payment",
    icon: <Cash />
  },
  "pp_card_stripe-connect": {
    title: "Credit card",
    icon: <CreditCard />
  },
  "pp_bank-transfer_bank-transfer": {
    title: "Bank transfer",
    icon: <Buildings />
  }
  // pp_stripe_stripe: {
  //   title: "Credit card",
  //   icon: <CreditCard />,
  // },
  // "pp_stripe-ideal_stripe": {
  //   title: "iDeal",
  //   icon: <CreditCard />,
  // },
  // "pp_stripe-bancontact_stripe": {
  //   title: "Bancontact",
  //   icon: <CreditCard />,
  // },
  // pp_paypal_paypal: {
  //   title: "PayPal",
  //   icon: <CreditCard />,
  // }
  // Add more payment providers here
};

// This only checks if it is native stripe for card payments, it ignores the other stripe-based providers
export const isStripe = (providerId?: string) => {
  return providerId?.startsWith("pp_card_stripe-connect");
};
export const isPaypal = (providerId?: string) => {
  return providerId?.startsWith("pp_paypal");
};
export const isManual = (providerId?: string) => {
  return providerId?.startsWith("pp_system_default");
};

/**
 * Lives in `lib/bank-transfer` with the rest of that provider's helpers, which
 * stay clear of the `loadStripe` call above; re-exported here so all four
 * provider predicates are still found in one place.
 */
export { isBankTransfer } from "./bank-transfer";
